import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=fba683ec&scoped=true&"
import script from "./AddressList.vue?vue&type=script&lang=js&"
export * from "./AddressList.vue?vue&type=script&lang=js&"
import style0 from "./AddressList.vue?vue&type=style&index=0&id=fba683ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba683ec",
  null
  
)

export default component.exports